import { render } from "./mauthor.vue?vue&type=template&id=1997b96a"
import script from "./mauthor.vue?vue&type=script&lang=js"
export * from "./mauthor.vue?vue&type=script&lang=js"
script.render = render

export default script